<template>
  <div class="move-list-ce-table-filters flex align-center column-sm">
    <div class="title">Filtros:</div>
    <date-picker v-model="filterInputs.start_at" format="YYYY-MM-DD" value-type="format" placeholder="Fecha de Inicio" class="filter-input" />
    <date-picker v-model="filterInputs.end_at" format="YYYY-MM-DD" value-type="format" placeholder="Fecha de Final" class="filter-input" />
    <input v-model="filterInputs.economic_number" type="text" placeholder="No. Económico" class="filter-input text-input">
    <button v-if="!loading.filter" @click.prevent="updateCrossings" class="btn">Filtrar</button>
    <button v-else class="btn" disabled>
      Cargando
      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-notch" class="loading-icon svg-inline--fa fa-circle-notch fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"></path></svg>
    </button>
    <button v-if="!loading.clearFilters" @click.prevent="clearFilters" class="btn clear-btn">Limpiar Filtros</button>
    <button v-else class="btn clear-btn" disabled>
      Cargando
      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-notch" class="loading-icon svg-inline--fa fa-circle-notch fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"></path></svg>
    </button>
    <button v-if="!loading.downloadFile" @click.prevent="downloadExcel" class="btn download-btn">Descargar Excel</button>
    <button v-else class="btn download-btn" disabled>
      Cargando
      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-notch" class="loading-icon svg-inline--fa fa-circle-notch fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"></path></svg>
    </button>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { mapActions } from 'vuex'
import { crossingsExcel } from '@/api/crossings'

export default {
  name: 'MoveListCeTableFilters',
  components: {
    DatePicker
  },
  data () {
    return {
      filterInputs: {
        economic_number: '',
        end_at: '',
        start_at: ''
      },
      filters: {},
      loading: {
        filter: false,
        clearFilters: false,
        downloadFile: false
      }
    }
  },
  methods: {
    ...mapActions('crossings', [
      'getCrossings'
    ]),
    commitsFilterInputs () {
      this.filters = { ...this.filterInputs }
    },
    updateCrossings () {
      this.loading.filter = true
      this.commitsFilterInputs()

      this.getCrossings(this.filters).then(response => {
      }).catch(_ => {
      }).finally(_ => {
        this.loading.filter = false
      })
    },
    clearFilters () {
      this.loading.clearFilters = true
      this.filterInputs = {
        economic_number: '',
        end_at: '',
        start_at: ''
      }

      this.commitsFilterInputs()

      this.getCrossings().then(response => {
      }).catch(_ => {
      }).finally(_ => {
        this.loading.clearFilters = false
      })
    },
    downloadExcel () {
      this.loading.downloadFile = true

      crossingsExcel(this.filters).then(response => {
        const link = document.createElement('a')

        link.href = URL.createObjectURL(new Blob([response.data], { type: 'application/xlsx' }))
        link.download = 'reporte_movimientos.xlsx'
        link.click()
      }).catch(_ => {
      }).finally(_ => {
        this.loading.downloadFile = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

.title {
  margin-right: 1rem;
}

.filter-input {
  margin: 0.5rem;
}

.text-input {
  font-size: 1rem;
  padding: 6px;
  line-height: 1.4;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;

  &:focus {
    outline-width: 0;
  }
}

.btn {
  font-size: 0.8rem;
  background-color: $light-blue;
  border-radius: 20px;
  color: white;
  border: 0;
  padding: 0.6rem 1.5rem;
  margin: 0.75rem 0.25rem;
  cursor: pointer;

  &:focus {
    outline-width: 0;
  }

  &.clear-btn {
    background-color: $white;
    color: $light-blue;
    font-weight: bold;
  }

  &.download-btn {
    background-color: $green;
  }
}

.loading-icon {
  animation-name: spin;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  width: 0.75rem;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>
